<app-loading *ngIf="contentReady"></app-loading>

<div class="addresses-container bg-light" *ngIf="!contentReady" style="margin-bottom: 70px;">





  @if(!tokenExists){
  <app-addaddress #addressFormRef (fees)="onAddressChange($event)"></app-addaddress>
  }
  @else{
  <app-useraddresses style="margin-top: 10px;" (fees)="onAddressChange($event)"></app-useraddresses>
  }


  <form class="form address-card" style="margin-top: 10px;" [formGroup]="data"
    (ngSubmit)="tokenExists?onSubmit():createUserAddPlaceOrder()">
    <div class="row">



      @if(isMobile){
      <div class="form-group" style="display: none;" *ngIf="selectedProductsDetails.length > 0">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'Product' | transloco }}</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of selectedProductsDetails">
              <td>{{ item.product.name_ar }}</td>
              <td>
                <input type="number" min="1" [(ngModel)]="item.quantity" [ngModelOptions]="{standalone: true}" />
              </td>
              <td>
                <input type="number" min="0" [(ngModel)]="item.price" [ngModelOptions]="{standalone: true}" />
              </td>
            </tr>

          </tbody>
        </table>

      </div>
      }@else{
      <div class="form-group" style="display: none;" *ngIf="selectedProductsDetails.length > 0">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'Product' | transloco }}</th>
              <th>{{ 'quantity' | transloco }}</th>
              <th>{{ 'price' | transloco }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of selectedProductsDetails">
              <td>{{ item.product.name_ar }}</td>
              <td>
                <input type="number" min="1" [(ngModel)]="item.quantity" [ngModelOptions]="{standalone: true}" />
              </td>
              <td>
                <input type="number" min="0" [(ngModel)]="item.price" [ngModelOptions]="{standalone: true}" />
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      }
      <!--

          -->
      @if(!tokenExists){

      <div class="col-md-12 mb-3">
        <label> {{'yourname' | transloco}}
        </label>
        <input class="form-control" type="text" id="name" formControlName="client_name"
          placeholder="{{'yourname' | transloco}}" [(ngModel)]="client_name" [ngClass]="{
                'is-invalid':
                data.controls['client_name'].touched &&
                data.controls['client_name'].errors,
                'is-valid':
                data.controls['client_name'].touched &&
                !data.controls['client_name'].errors,
                'is-touched':
                data.controls['client_name'].untouched &&
                !data.controls['client_name'].errors,
            }" />
      </div>
      <div class="col-md-12 mb-3">
        <label>{{'yournumber' | transloco}}</label>
        <input class="form-control" type="text" maxlength="11" inputmode="numeric" pattern="[0-9]*"
          (keypress)="onlyNumbers($event)" id="name" formControlName="phone_number"
          placeholder="{{'yournumber' | transloco}}" [(ngModel)]="phone_number" [ngClass]="{
                'is-invalid':
                data.controls['phone_number'].touched &&
                data.controls['phone_number'].errors,
                'is-valid':
                data.controls['phone_number'].touched &&
                !data.controls['phone_number'].errors,
                'is-touched':
                data.controls['phone_number'].untouched &&
                !data.controls['phone_number'].errors,
            }" />
        <div class="text-danger mt-1"
          *ngIf="data.controls['phone_number'].touched && data.controls['phone_number'].invalid">
          <span *ngIf="data.controls['phone_number'].errors?.['required']">
            {{ isAr ? 'ادخل رقم الموبايل' : 'Enter phone number' }}
          </span>

          <span *ngIf="
    data.controls['phone_number'].errors?.['minlength'] ||
    data.controls['phone_number'].errors?.['maxlength'] ||
    data.controls['phone_number'].errors?.['pattern']
  ">
            {{ isAr ? 'ادخل رقم صحيح' : 'Enter a valid phone number' }}
          </span>
        </div>
      </div>
      <!-- <div class="col-md-12 mb-3">
        <label>{{'yoursecnumber' | transloco}} </label>
        <input class="form-control" type="text" id="name" formControlName="another_phone"
         placeholder="{{'yoursecnumber' | transloco}}" [(ngModel)]="another_phone" />
      </div> -->


      }
      <div class="col-md-12 mb-3">
        <label>{{ 'note' | transloco }} </label>
        <input class="form-control" type="text" id="phone" formControlName="note" placeholder="{{ 'note' | transloco }}"
          [(ngModel)]="note" />
      </div>
    </div>
    <div class="address-card">
      <div class="col-md-12 mb-3 promo-code">
        <label> <img class="profile-icon" src="/assets/e-commerce/icons/05_coupon.svg">
          {{'promo code' | transloco}} </label>
        <input type="text" class="form-control" #promo placeholder="{{'add promo code'| transloco}}">
        <button class="apply-btn form-control" type="button" (click)="addPromoCode(promo.value)">
          {{ 'apply' | transloco }}
        </button>
      </div>
      @if(token && balance != 0){
      <div class="col-md-12 mb-3 promo-code">
        <label> <img class="profile-icon" src="/assets/e-commerce/icons/53.webp">
          {{'wallet' | transloco}} </label>
        <div class="form-control">{{balance}} {{'egpe' | transloco}}</div>
        <button class="apply-btn form-control" type="button" [disabled]="walletApplied" (click)="applyWallet()">
          {{ 'use' | transloco }}
        </button>
      </div>
      }
      <div class="price-box">
        <div class="price-row">
          <span>{{'subtotal' | transloco}}</span>
          <span>{{carttotal}} {{'egpe' | transloco}}</span>
        </div>
        <div class="price-row discount">
          <span>{{'before discount' | transloco}}</span>
          <span>- {{yourSave}} {{'egpe' | transloco}}</span>
        </div>

        <div class="price-row">
          <span style="text-decoration: underline #4bc275;">{{'you save' | transloco}} </span>
          <span style="text-decoration: underline #4bc275;">{{yourSave - carttotal}} {{'egpe' | transloco}}</span>
        </div>

        <div class="price-row">
          <span>{{'delivery fees' | transloco}}</span>
          <span>{{delivery_fees}} {{'egpe' | transloco}}</span>
        </div>

        <div class="price-row" style="font-weight:bold;">
          <span> {{'total' | transloco}}</span>
          <span>{{carttotal + delivery_fees}} {{'egpe' | transloco}}</span>
        </div>
      </div>
    </div>
    <div class="cart-summary" style="margin-top: 10px;display: none;">
      <label class="fw-bold">{{ 'payment method' | transloco }}</label>

      <div class="payment-methods">

        <!-- CASH -->
        <div class="payment-card" [class.active]="paymentType === 0" (click)="selectPayment(0)">
          <span class="icon"><img class="profile-icon" src="/assets/e-commerce/icons/40.webp"></span>
          <span>{{ 'cash' | transloco }}</span>
        </div>

        <!-- ONLINE -->
        <div class="payment-card" [class.active]="paymentType === 3" (click)="selectPayment(3)">

          <span class="icon"><img class="profile-icon" src="/assets/e-commerce/icons/43.webp"></span>
          <span>{{ 'online payment' | transloco }}</span>
        </div>

      </div>
    </div>


    <div class="cart-summary">
      <div class="cashback-hint">
        <span class="icon"><img class="profile-icon" src="/assets/e-commerce/icons/40.webp"></span>
        <span>
          {{ isAr ? 'هيجيلك 5% كاش باك على الأوردر ده في المحفظة بعد استلم الطلب' :
          'You will get 5% cashback in your wallet after order complete' }}
        </span>
      </div>

      <button type="submit" class="fromsave accont">
        {{ "ordernow" | transloco }}
      </button>
    </div>


  </form>


</div>